import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import {API_URL} from "../../../SHARED/config/apiEndpoints";
import Moment from "react-moment";
import 'moment/locale/ro';
import {Link} from 'react-router-dom';
import { slugify } from "../../../SHARED/helpers/general.helper";
import Parser from 'html-react-parser';

class GroupedNews extends Component {

    showItems = element => {
        if(element['category_articles'].length > 0 ) {
            return <Fragment>
                <div className="col-12 three-news" key={this.props.key}>
                    <Link to={`/stiri/${slugify(element.category_name)}`}> <p className="headline-news blue-text underline-text">{element.category_name}</p> </Link>
                    <div className="row">
                        {
                            this.props.nw['category_articles'].map((item, j) => {
                                return (
                                    <div className="col-lg-4" key={j}>
                                        <Link to={'/stire/'+ item.article_id + '/' + slugify(item.article_title)}>
                                            <img src={ API_URL + item.article_image } className="img-fluid w-100" alt={'Cinemap'}/>
                                        </Link>
                                        <Link className ="white-text" to={'/stire/'+ item.article_id + '/' + slugify(item.article_title)}>{item.article_title}</Link>
                                        <span className="last-news-date dark-grey-text">
                                            <Moment format="DD MMMM YYYY HH:mm" locale="ro" unix>
                                                { item.article_created }
                                            </Moment>
                                        </span>
                                        <div className="article-descr ">
                                            {Parser(item.article_body)}
                                            <Link to={`/stire/${item.article_id}/${slugify(item.article_title)}`} >
                                                <span className="read-more">Citeşte tot >></span>
                                            </Link>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </Fragment>
        }
    };

    displayNews = () => {
        return this.showItems(this.props.nw)
    };

    render() {
        return (
            <Fragment>
                { this.displayNews() }
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(GroupedNews);





// WEBPACK FOOTER //
// ./src/FO/components/news/groupednews.component.js